export default __webpack_public_path__ + "static/media/Deed of Contract_11.02864b81.jpg";